import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { canActivate } from './core/guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    canActivate: [canActivate],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth-routes').then(m => m.routes)
      }
    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [canActivate],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages-routes').then(m => m.routes)
      }
    ]
  }
];
RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled',
  scrollOffset: [0, 0]
});
